import { featureFlags } from '../../../config/featureFlags';
import { logger } from '../../../utils/logger';

type ReportAnalyticsEvent =
  | 'report.generate'
  | 'report.generate.success'
  | 'report.generate.failure'
  | 'report.download';

type TrackPayload = Record<string, unknown>;

export function trackReportEvent(
  event: ReportAnalyticsEvent,
  payload: TrackPayload,
): void {
  if (!featureFlags.ENABLE_ANALYTICS) {
    return;
  }

  if (typeof window !== 'undefined') {
    const analyticsGlobal = window as typeof window & {
      analytics?: {
        track?: (eventName: ReportAnalyticsEvent, data: TrackPayload) => void;
      };
    };

    const analyticsClient = analyticsGlobal.analytics;

    if (analyticsClient?.track) {
      analyticsClient.track(event, payload);
      return;
    }
  }

  logger.info(
    `Analytics event: ${event}`,
    { component: 'MarketingReport' },
    payload,
  );
}
